import AdAlert from './AdAlert';

export default AdAlert;
